import { proxy } from "valtio";
import { GetBusinessApplicationsObj } from "../api/business/applications/types";

export const applicationDataStore = proxy<{
  applicationData: GetBusinessApplicationsObj | undefined;
}>({
  applicationData: undefined,
});
